// extracted by mini-css-extract-plugin
export default {"Effect":"Effect_Effect__uGHwo","Alarm":"Effect_Alarm__AbwO8","alarm":"Effect_alarm__vsEuu","Visible":"Effect_Visible__5Abfb"};